import {Node } from "@xanadu/model";
import { BaseMenu } from "./base-menu";

export abstract class MenuBuilder {
    public abstract Build(node: Node, clipboard?: Node): BaseMenu;
}
